var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockOpen24Dp434343Fill0Wght400Grad0Opsz24 = function SvgLockOpen24Dp434343Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#434343",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-80v-560h440v-80q0-50-35-85t-85-35-85 35-35 85h-80q0-83 58.5-141.5T480-920t141.5 58.5T680-720v80h120v560zm80-80h480v-400H240zm240-120q33 0 56.5-23.5T560-360t-23.5-56.5T480-440t-56.5 23.5T400-360t23.5 56.5T480-280M240-160v-400z"
  })));
};
export default SvgLockOpen24Dp434343Fill0Wght400Grad0Opsz24;